module.exports = __webpack_public_path__ + "static/media/HeroBackground.d3ea8ff1.png";